<template>
  <div>
    <!-- 主表单弹窗 -->
    <a-modal
        v-model="visible"
        :title="isEdit ? (isEditTitle || '编辑车辆') : (isAddTitle || '新增车辆')"
        :footer="null"
        width="1200px"
        @cancel="handleCancel"
        class="modern-car-modal"
        :bodyStyle="{ padding: '24px', background: '#f8fafc' }"
        :maskClosable="false"
    >
      <div class="car-form-container">
        <!-- 基本信息卡片 -->
        <div class="form-card">
          <div class="card-header">
            <div class="card-title">
              <a-icon type="car" class="title-icon" />
              <span>基本信息</span>
            </div>
            <div class="card-subtitle">车辆基础信息和技术参数</div>
          </div>
          <div class="card-content">
            <a-row :gutter="[24, 16]">
              <!-- 第一行：核心信息 -->
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车牌号 <span class="required">*</span></label>
                  <a-input
                      v-model="form.plateNumber"
                      placeholder="请输入车牌号"
                      :class="{ 'error-input': errors.plateNumber }"
                      :disabled="isEdit"
                      size="large"
                  />
                  <div v-if="errors.plateNumber" class="error-message">{{ errors.plateNumber }}</div>
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-select">
                <div class="form-item">
                  <label class="form-label">车辆类型</label>
                  <a-select
                      v-model="form.vehicleType"
                      placeholder="请选择车辆类型"
                      allowClear
                      size="large"
                  >
                    <a-select-option v-for="item in vehicleTypeOptions" :key="item.value" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </div>
              </a-col>
              <a-col :span="8"  class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆品牌</label>
                  <a-input
                      v-model="form.vehicleBrand"
                      placeholder="请输入车辆品牌"
                      size="large"
                  />
                </div>
              </a-col>

              <!-- 第二行：识别信息 -->
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆识别代码</label>
                  <a-input
                      v-model="form.vehicleIdentificationNumber"
                      placeholder="请输入车辆识别代码"
                      :disabled="isEdit"
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">发动机号</label>
                  <a-input
                      v-model="form.engineNumber"
                      placeholder="请输入发动机号"
                      size="large"
                  />
                </div>
              </a-col>

              <!-- 第三行：技术参数 -->
              <a-col :span="8" class="ant-col-customize-select">
                <div class="form-item">
                  <label class="form-label">燃料类型</label>
                  <a-select
                      v-model="form.fuelType"
                      placeholder="请选择燃料类型"
                      allowClear
                      size="large"
                  >
                    <a-select-option v-for="item in fuelTypeOptions" :key="item.value" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">额定百公里油耗(L/KM)</label>
                  <a-input
                      v-model="form.fuelConsumption"
                      placeholder="请输入额定百公里油耗"
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆颜色</label>
                  <a-input
                      v-model="form.vehicleColor"
                      placeholder="请输入车辆颜色"
                      size="large"
                  />
                </div>
              </a-col>

              <!-- 第四行：载重信息 -->
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">核定载质量(吨)</label>
                  <a-input
                      v-model="form.maxLoad"
                      placeholder="请输入核定载质量"
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">载货容积(m³)</label>
                  <a-input
                      v-model="form.volume"
                      placeholder="请输入载货容积"
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-select">
                <div class="form-item">
                  <label class="form-label">车辆状态</label>
                  <a-select
                      v-model="form.vehicleStatus"
                      placeholder="请选择车辆状态"
                      allowClear
                      size="large"
                  >
                    <a-select-option value="active">使用中</a-select-option>
                    <a-select-option value="inactive">停用</a-select-option>
                    <a-select-option value="maintenance">维修中</a-select-option>
                    <a-select-option value="scrapped">报废</a-select-option>
                  </a-select>
                </div>
              </a-col>

              <!-- 第五行：备注和附件 -->
              <a-col :span="16" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">备注</label>
                  <a-textarea
                      v-model="form.remarks"
                      placeholder="请输入备注信息"
                      :rows="3"
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆附件</label>
                  <FileUpload
                      v-model="form.vehicleAnnex"
                      title="车辆附件上传"
                      title-icon="file-image-outlined"
                      :max-count="3"
                      business-type="vehicle-annex"
                      @preview="showPreview"
                  />
                </div>
              </a-col>
            </a-row>
          </div>
        </div>

        <!-- 档案信息卡片 -->
        <div class="form-card">
          <div class="card-header">
            <div class="card-title">
              <a-icon type="folder" class="title-icon" />
              <span>档案信息</span>
            </div>
            <div class="card-subtitle">车辆档案管理和证件信息</div>
          </div>
          <div class="card-content">
            <a-row :gutter="[24, 16]">
              <!-- 第一行：基础档案 -->
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆编号 <span class="required">*</span></label>
                  <a-input
                      v-model="form.vehicleNumber"
                      placeholder="请输入车辆编号"
                      :class="{ 'error-input': errors.vehicleNumber }"
                      :disabled="isEdit"
                      size="large"
                  />
                  <div v-if="errors.vehicleNumber" class="error-message">{{ errors.vehicleNumber }}</div>
                </div>
              </a-col>
              <!--              <a-col :span="8" class="ant-col-customize-select">-->
              <!--                <div class="form-item">-->
              <!--                  <label class="form-label required">车辆归属</label>-->
              <!--                  <a-select-->
              <!--                      v-model="form.vehicle"-->
              <!--                      placeholder="请选择车辆归属"-->
              <!--                      :class="{ 'error-input': errors.vehicle }"-->
              <!--                      size="large"-->
              <!--                  >-->
              <!--                    <a-select-option value="自有车">自有车</a-select-option>-->
              <!--                    <a-select-option value="挂靠收款">挂靠收款</a-select-option>-->
              <!--                  </a-select>-->
              <!--                  <div v-if="errors.vehicle" class="error-message">{{ errors.vehicle }}</div>-->
              <!--                </div>-->
              <!--              </a-col>-->
              <!--              <a-col :span="8" class="ant-col-customize-input">-->
              <!--                <div class="form-item">-->
              <!--                  <label class="form-label">所属车队</label>-->
              <!--                  <a-input-->
              <!--                      v-model="form.belongingFleet"-->
              <!--                      placeholder="请输入所属车队"-->
              <!--                      size="large"-->
              <!--                  />-->
              <!--                </div>-->
              <!--              </a-col>-->

              <!-- 第二行：车主信息 -->
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车主姓名</label>
                  <a-input
                      v-model="form.carOwner"
                      placeholder="请输入车主姓名"
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车主手机号</label>
                  <a-input
                      v-model="form.carOwnerPhone"
                      placeholder="请输入车主手机号"
                      size="large"
                  />
                </div>
              </a-col>

              <!-- 第三行：日期信息 -->
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆上户日期</label>
                  <a-date-picker
                      v-model="form.vehicleRegistrationTime"
                      placeholder="请选择日期"
                      size="large"
                      style="width: 100%"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆入公司日期</label>
                  <a-date-picker
                      v-model="form.registrationDate"
                      placeholder="请选择日期"
                      size="large"
                      style="width: 100%"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆期初公里数</label>
                  <a-input
                      v-model="form.vehicleInitialMileage"
                      placeholder="请输入期初公里数"
                      size="large"
                  />
                </div>
              </a-col>
            </a-row>
          </div>
        </div>

        <!-- 证件信息卡片 -->
        <div class="form-card">
          <div class="card-header">
            <div class="card-title">
              <a-icon type="safety-certificate" class="title-icon" />
              <span>证件信息</span>
            </div>
            <div class="card-subtitle">行驶证、保险等证件管理</div>
          </div>
          <div class="card-content">
            <a-row :gutter="[24, 16]">
              <!-- 第一行：行驶证信息 -->
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">行驶证号</label>
                  <a-input
                      v-model="form.drivingPermitNumber"
                      placeholder="请输入行驶证号"
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">行驶证到期时间</label>
                  <a-date-picker
                      v-model="form.drivingPermitExpireTime"
                      placeholder="请选择日期"
                      size="large"
                      style="width: 100%"
                  />
                </div>
              </a-col>

              <!-- 第二行：保险信息 -->
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">商业险到期时间</label>
                  <a-date-picker
                      v-model="form.insuranceExpireTime"
                      placeholder="请选择日期"
                      size="large"
                      style="width: 100%"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">交强险到期时间</label>
                  <a-date-picker
                      v-model="form.compulsoryInsuranceExpireTime"
                      placeholder="请选择日期"
                      size="large"
                      style="width: 100%"
                  />
                </div>
              </a-col>

              <!-- 第三行：GPS和产权 -->
<!--              <a-col :span="8" class="ant-col-customize-input">-->
<!--                <div class="form-item">-->
<!--                  <label class="form-label">GPS开始时间</label>-->
<!--                  <a-date-picker-->
<!--                      v-model="form.gpsStartTime"-->
<!--                      placeholder="请选择日期"-->
<!--                      size="large"-->
<!--                      style="width: 100%"-->
<!--                  />-->
<!--                </div>-->
<!--              </a-col>-->
<!--              <a-col :span="8" class="ant-col-customize-input">-->
<!--                <div class="form-item">-->
<!--                  <label class="form-label">GPS结束时间</label>-->
<!--                  <a-date-picker-->
<!--                      v-model="form.gpsEndTime"-->
<!--                      placeholder="请选择日期"-->
<!--                      size="large"-->
<!--                      style="width: 100%"-->
<!--                  />-->
<!--                </div>-->
<!--              </a-col>-->
              <!--              <a-col :span="8" class="ant-col-customize-select">-->
              <!--                <div class="form-item">-->
              <!--                  <label class="form-label">产权登记在公司</label>-->
              <!--                  <a-select-->
              <!--                      v-model="form.vehicleCertificateLocation"-->
              <!--                      placeholder="请选择"-->
              <!--                      size="large"-->
              <!--                  >-->
              <!--                    <a-select-option value="1">是</a-select-option>-->
              <!--                    <a-select-option value="0">否</a-select-option>-->
              <!--                  </a-select>-->
              <!--                </div>-->
              <!--              </a-col>-->
            </a-row>
          </div>
        </div>

        <!-- 附件信息卡片 -->
        <div class="form-card">
          <div class="card-header">
            <div class="card-title">
              <a-icon type="paper-clip" class="title-icon" />
              <span>附件管理</span>
            </div>
            <div class="card-subtitle">上传相关证件和文档</div>
          </div>
          <div class="card-content">
            <a-row :gutter="[24, 24]">
              <!-- 行驶证附件 -->
              <a-col :span="8">
                <div class="attachment-section">
                  <FileUpload
                      v-model="form.drivingPermitAnnex"
                      title="行驶证附件"
                      title-icon="file-text-outlined"
                      :max-count="3"
                      business-type="vehicle-annex"
                      upload-text="点击上传"
                      :show-hint="false"
                      limit-text="已达上限"
                      @preview="showPreview"
                  />
                </div>
              </a-col>

              <!-- 运营证附件 -->
              <a-col :span="8">
                <div class="attachment-section">
                  <FileUpload
                      v-model="form.tradingCardAnnex"
                      title="运营证附件"
                      title-icon="file-text-outlined"
                      :max-count="3"
                      business-type="vehicle-annex"
                      upload-text="点击上传"
                      :show-hint="false"
                      limit-text="已达上限"
                      @preview="showPreview"
                  />
                </div>
              </a-col>

              <!-- 产权证附件 -->
              <a-col :span="8">
                <div class="attachment-section">
                  <FileUpload
                      v-model="form.vehicleCertificateAnnex"
                      title="产权证附件"
                      title-icon="file-text-outlined"
                      :max-count="3"
                      business-type="vehicle-annex"
                      upload-text="点击上传"
                      :show-hint="false"
                      limit-text="已达上限"
                      @preview="showPreview"
                  />
                </div>
              </a-col>
            </a-row>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="form-actions">
          <a-button @click="handleCancel" size="large" class="cancel-btn">
            取消
          </a-button>
          <a-button type="primary" @click="handleSave" size="large" class="save-btn">
            <a-icon type="save" />
            保存
          </a-button>
        </div>
      </div>
    </a-modal>
    <!-- 图片预览组件 -->
    <ImagePreview
        :visible="previewVisible"
        :image-url="currentImageUrl"
        :image-alt="currentImageAlt"
        @close="handlePreviewClose"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import ImagePreview from '@/components/file/ImagePreview.vue'
import FileUpload from '@/components/file/FileUpload.vue'

export default {
  name: "CarFormModal",
  components: {
    ImagePreview,
    FileUpload
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isEditTitle: {
      type: String,
      default: '编辑车辆'
    },
    isAddTitle: {
      type: String,
      default: '新增车辆'
    },
    vehicleTypeOptions: {
      type: Array,
      default: () => [
        {value: '4.2m', label: '4.2m'},
        {value: '6.8m', label: '6.8m'},
        {value: '7.6m', label: '7.6m'},
        {value: '9.6m', label: '9.6m'},
        {value: '13m', label: '13m'},
        {value: '17.5m', label: '17.5m'},
        {value: 'MPV', label: 'MPV'}
      ]
    },
    fuelTypeOptions: {
      type: Array,
      default: () => [
        {value: '柴油', label: '柴油'},
        {value: '汽油', label: '汽油'},
        {value: '混动', label: '混动'},
        {value: '纯电', label: '纯电'}
      ]
    }
  },
  data() {
    return {
      form: {
        plateNumber: '',
        vehicleType: undefined,
        vehicleLength: '',
        vehicleIdentificationNumber: '',
        engineNumber: '',
        fuelConsumption: '',
        fuelType: undefined,
        maxLoad: '',
        volume: '',
        vehicleBrand: '',
        vehicleColor: '',
        remarks: '',
        vehicleAnnex: [], // 保证为数组
        vehicleNumber: '',
        vehicleStatus: undefined,
        carOwner: '',
        carOwnerPhone: '',
        // vehicle: '',
        // belongingFleet: '',
        vehicleRegistrationTime: null,
        registrationDate: null,
        vehicleInitialMileage: '',
        drivingPermitExpireTime: null,
        drivingPermitNumber: '',
        insuranceExpireTime: null,
        compulsoryInsuranceExpireTime: null,
        // vehicleCertificateLocation: null,
        gpsStartTime: null,
        gpsEndTime: null,
        drivingPermitAnnex: [], // 保证为数组
        tradingCardAnnex: [], // 保证为数组
        vehicleCertificateAnnex: [] // 保证为数组
      },
      errors: {
        plateNumber: '',
        vehicleNumber: '',
      },
      // 图片预览相关
      previewVisible: false,
      currentImageUrl: '',
      currentImageAlt: ''
    }
  },
  computed: {
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.resetForm()
      }
    }
  },
  methods: {
    // 重置表单
    resetForm() {
      this.form = {
        plateNumber: '',
        vehicleType: undefined,
        vehicleLength: '',
        vehicleIdentificationNumber: '',
        engineNumber: '',
        fuelConsumption: '',
        fuelType: undefined,
        maxLoad: '',
        volume: '',
        vehicleBrand: '',
        vehicleColor: '',
        remarks: '',
        vehicleAnnex: [], // 保证为数组
        vehicleNumber: '',
        vehicleStatus: undefined,
        carOwner: '',
        carOwnerPhone: '',
        // vehicle: '',
        // belongingFleet: '',
        vehicleRegistrationTime: null,
        registrationDate: null,
        vehicleInitialMileage: '',
        drivingPermitExpireTime: null,
        drivingPermitNumber: '',
        insuranceExpireTime: null,
        compulsoryInsuranceExpireTime: null,
        // vehicleCertificateLocation: null,
        gpsStartTime: null,
        gpsEndTime: null,
        drivingPermitAnnex: [], // 保证为数组
        tradingCardAnnex: [], // 保证为数组
        vehicleCertificateAnnex: [] // 保证为数组
      }
      this.clearErrors()
    },

    // 清除错误信息
    clearErrors() {
      this.errors = {
        plateNumber: '',
        vehicleNumber: '',
      }
    },



    // 验证表单
    validateForm() {
      this.clearErrors()
      let isValid = true

      // 车牌号验证
      if (!this.form.plateNumber || this.form.plateNumber.trim() === '') {
        this.errors.plateNumber = '请输入车牌号'
        isValid = false
      }

      // 行驶证号验证
      if (!this.form.vehicleNumber || this.form.vehicleNumber.trim() === '') {
        this.errors.vehicleNumber = '请输入车辆编号'
        isValid = false
      }

      return isValid
    },

    // 设置表单数据（用于编辑）
    setFormData(data) {
      // 处理附件字段，将String或数组统一转换为 a-upload 需要的对象数组结构
      const parseAnnex = (annexData) => {
        if (!annexData) return []
        let arr = []
        if (Array.isArray(annexData)) {
          arr = annexData
        } else {
          try {
            arr = JSON.parse(annexData)
          } catch (e) {
            arr = []
          }
        }
        // 统一转为 { uid, url, name, status } 结构
        return arr.map((item, idx) => {
          if (typeof item === 'string') {
            const name = item.split('/').pop() || `图片${idx + 1}`
            return {
              uid: item + '_' + idx,
              url: item,
              name,
              status: 'done'
            }
          }
          // 如果已经是对象，补全字段
          return {
            uid: item.uid || (item.url ? item.url + '_' + idx : idx),
            url: item.url || '',
            name: item.name || (item.url ? item.url.split('/').pop() : `图片${idx + 1}`),
            status: item.status || 'done'
          }
        })
      }

      this.form = {
        id: data.id || null,
        plateNumber: data.plateNumber || '',
        vehicleType: data.vehicleType || undefined,
        vehicleLength: data.vehicleLength || '',
        vehicleIdentificationNumber: data.vehicleIdentificationNumber || '',
        engineNumber: data.engineNumber || '',
        fuelConsumption: data.fuelConsumption || '',
        fuelType: data.fuelType || undefined,
        approvedLoad: data.approvedLoad || '',
        maxLoad: data.maxLoad || '',
        volume: data.volume || '',
        vehicleBrand: data.vehicleBrand || '',
        vehicleColor: data.vehicleColor || '',
        remarks: data.remarks || '',
        vehicleAnnex: parseAnnex(data.vehicleAnnex),
        vehicleNumber: data.vehicleNumber || '',
        vehicleStatus: data.vehicleStatus || undefined,
        carOwner: data.carOwner || '',
        carOwnerPhone: data.carOwnerPhone || '',
        // vehicle: data.vehicle || '',
        // belongingFleet: data.belongingFleet || '',
        vehicleRegistrationTime: data.vehicleRegistrationTime || null,
        registrationDate: data.registrationDate || null,
        vehicleInitialMileage: data.vehicleInitialMileage || '',
        drivingPermitExpireTime: data.drivingPermitExpireTime || null,
        drivingPermitNumber: data.drivingPermitNumber || '',
        insuranceExpireTime: data.insuranceExpireTime || null,
        compulsoryInsuranceExpireTime: data.compulsoryInsuranceExpireTime || null,
        // vehicleCertificateLocation: data.vehicleCertificateLocation !== null && data.vehicleCertificateLocation !== undefined ? String(data.vehicleCertificateLocation) : null,
        gpsStartTime: data.gpsStartTime || null,
        gpsEndTime: data.gpsEndTime || null,
        drivingPermitAnnex: parseAnnex(data.drivingPermitAnnex),
        tradingCardAnnex: parseAnnex(data.tradingCardAnnex),
        vehicleCertificateAnnex: parseAnnex(data.vehicleCertificateAnnex)
      }
      this.clearErrors()
    },

    // 取消
    handleCancel() {
      this.$emit('cancel')
    },

    // 保存
    handleSave() {
      if (this.validateForm()) {
        // 日期格式化函数
        const formatDate = (date) => date ? dayjs(date).format('YYYY-MM-DD') : null

        // 组装 transportCarInfo
        const transportCarInfo = {
          plateNumber: this.form.plateNumber,
          vehicleIdentificationNumber: this.form.vehicleIdentificationNumber,
          vehicleType: this.form.vehicleType,
          vehicleBrand: this.form.vehicleBrand,
          vehicleColor: this.form.vehicleColor,
          engineNumber: this.form.engineNumber,
          fuelConsumption: this.form.fuelConsumption,
          fuelType: this.form.fuelType,
          productionDate: formatDate(this.form.productionDate),
          purchaseDate: formatDate(this.form.purchaseDate),
          vehicleStatus: this.form.vehicleStatus,
          maxLoad: this.form.maxLoad,
          volume: this.form.volume,
          remarks: this.form.remarks,
          vehicleAnnex: JSON.stringify(this.form.vehicleAnnex.map(f => f.url))
        }
        // 编辑时带id
        if (this.form.id) {
          transportCarInfo.id = this.form.id
        }

        // 组装 transportCarAssociation
        const transportCarAssociation = {
          vehicleNumber: this.form.vehicleNumber,
          carOwner: this.form.carOwner,
          carOwnerPhone: this.form.carOwnerPhone,
          vehicle: this.form.vehicle,
          // belongingFleet: this.form.belongingFleet,
          vehicleRegistrationTime: formatDate(this.form.vehicleRegistrationTime),
          registrationDate: formatDate(this.form.registrationDate),
          vehicleInitialMileage: this.form.vehicleInitialMileage,
          drivingPermitExpireTime: formatDate(this.form.drivingPermitExpireTime),
          drivingPermitNumber: this.form.drivingPermitNumber,
          insuranceExpireTime: formatDate(this.form.insuranceExpireTime),
          compulsoryInsuranceExpireTime: formatDate(this.form.compulsoryInsuranceExpireTime),
          // vehicleCertificateLocation: this.form.vehicleCertificateLocation,
          gpsStartTime: formatDate(this.form.gpsStartTime),
          gpsEndTime: formatDate(this.form.gpsEndTime),
          drivingPermitAnnex: JSON.stringify(this.form.drivingPermitAnnex.map(f => f.url)),
          tradingCardAnnex: JSON.stringify(this.form.tradingCardAnnex.map(f => f.url)),
          vehicleCertificateAnnex: JSON.stringify(this.form.vehicleCertificateAnnex.map(f => f.url))
        }

        // 组装最终数据
        const params = {
          transportCarInfo,
          transportCarAssociation
        }

        this.$emit('save', params, this.isEdit)
      }
    },
    showPreview(url) {
      this.currentImageUrl = url
      this.currentImageAlt = url.split('/').pop()
      this.previewVisible = true
    },
    handlePreviewClose() {
      this.previewVisible = false
      this.currentImageUrl = ''
      this.currentImageAlt = ''
    },

  }
}
</script>

<style lang="less" scoped>
.modern-car-modal {
  .ant-modal-content {
    border-radius: 12px;
    background: #f8fafc;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .ant-modal-header {
    border-radius: 12px 12px 0 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-bottom: none;
    padding: 20px 24px;

    .ant-modal-title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }
  }

  .ant-modal-close {
    color: #fff;
    top: 20px;
    right: 24px;

    &:hover {
      color: #f1f5f9;
    }
  }
}

.car-form-container {
  padding: 0px;
  background: #f8fafc;
}

.form-card {
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    transform: translateY(-1px);
  }
}

.card-header {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;

  .anticon {
    color: #3b82f6;
    font-size: 18px;
  }
}

.card-subtitle {
  font-size: 13px;
  color: #64748b;
  margin: 4px 0 0 0;
  font-weight: 400;
}

.form-item {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.form-label {
  font-weight: 600;
  color: #374151;
  font-size: 14px;
  margin-bottom: 6px;
  display: block;
  line-height: 1.4;
}

.required {
  color: #ef4444;
  font-weight: bold;
}

.car-input {
  width: 100% !important;
  height: 40px !important;
  border-radius: 8px !important;
  background: #fff !important;
  border: 1px solid #d1d5db !important;
  font-size: 14px;
  line-height: 40px !important;
  box-sizing: border-box;
  transition: all 0.2s ease;

  &:hover {
    border-color: #9ca3af !important;
  }

  &:focus {
    border-color: #3b82f6 !important;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  }
}

.error-input {
  border-color: #ef4444 !important;
  &:focus {
    border-color: #ef4444 !important;
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1) !important;
  }
}

.error-message {
  color: #ef4444;
  font-size: 12px;
  margin-top: 4px;
  line-height: 1.4;
  min-height: 16px;
  display: block;
}

/* 下拉选择器样式 */
:deep(.car-select .ant-select-selector) {
  width: 100% !important;
  border-radius: 8px !important;
  background: #fff !important;
  border: 1px solid #d1d5db !important;
  font-size: 14px;
  line-height: 40px !important;
  box-sizing: border-box;
  padding: 0 12px !important;
  height: 40px !important;
  transition: all 0.2s ease;
}

:deep(.car-select .ant-select-selector:hover) {
  border-color: #9ca3af !important;
}

:deep(.car-select.ant-select-focused .ant-select-selector) {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
}

:deep(.car-select.error-input .ant-select-selector) {
  border-color: #ef4444 !important;
}

:deep(.car-select.error-input.ant-select-focused .ant-select-selector) {
  border-color: #ef4444 !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1) !important;
}

:deep(.car-select .ant-select-selection-search-input) {
  height: 40px !important;
}

:deep(.car-select .ant-select-selection-placeholder) {
  line-height: 40px !important;
  color: #9ca3af !important;
}

:deep(.car-select .ant-select-arrow) {
  top: 50% !important;
  transform: translateY(-50%);
  color: #6b7280;
}

/* 日期选择器样式 */
.car-picker .ant-picker {
  width: 100% !important;
  height: 40px !important;
  border-radius: 8px !important;
  background: #fff !important;
  border: 1px solid #d1d5db !important;
  font-size: 14px;
  line-height: 40px !important;
  box-sizing: border-box;
  padding: 0 12px !important;
  transition: all 0.2s ease;
}

.car-picker .ant-picker:hover {
  border-color: #9ca3af !important;
}

.car-picker .ant-picker.ant-picker-focused {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
}

.car-picker .ant-picker-input > input {
  height: 40px !important;
  line-height: 40px !important;
}

.car-picker .ant-picker-suffix {
  top: 50% !important;
  transform: translateY(-50%);
  color: #6b7280;
}

.car-picker .ant-picker-input > input::placeholder {
  color: #9ca3af !important;
}

/* 文件上传样式 */
.upload-area {
  padding: 20px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.upload-area.enhanced {
  padding: 24px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  transition: all 0.3s ease;
}

.upload-area.enhanced:hover {
  border-color: #3b82f6;
  box-shadow: 0 8px 25px rgba(59, 130, 246, 0.1);
}

.upload-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
}

.upload-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

.title-icon {
  color: #3b82f6;
  font-size: 18px;
}

.upload-count {
  background: #3b82f6;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.upload-tips {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 12px 16px;
  background: #eff6ff;
  border-radius: 8px;
  border-left: 4px solid #3b82f6;
}

.tips-icon {
  color: #3b82f6;
  font-size: 14px;
}

.upload-tips span {
  color: #1e40af;
  font-size: 13px;
  line-height: 1.4;
}

.upload-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.upload-thumb {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid #e2e8f0;
  transition: all 0.3s ease;

  &:hover {
    border-color: #3b82f6;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
    transform: translateY(-2px);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.upload-thumb.enhanced {
  width: 90px;
  height: 90px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.upload-thumb.enhanced.uploading {
  border-color: #3b82f6;
  background: #eff6ff;
}

.upload-thumb.enhanced.error {
  border-color: #ef4444;
  background: #fef2f2;
}

.thumb-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.uploading-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #3b82f6;
}

.loading-icon {
  font-size: 24px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.upload-progress {
  font-size: 12px;
  font-weight: 600;
}

.error-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #ef4444;
}

.error-icon {
  font-size: 24px;
}

.error-text {
  font-size: 10px;
  font-weight: 500;
}

.upload-remove {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 20px;
  height: 20px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
    transform: scale(1.1);
  }
}

.upload-btn {
  width: 80px;
  height: 80px;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #3b82f6;
    background: #f8fafc;
  }
}

.upload-btn.enhanced {
  width: 90px;
  height: 90px;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

.upload-btn.enhanced:hover {
  border-color: #3b82f6;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(59, 130, 246, 0.15);
}

.upload-btn.enhanced:active {
  transform: translateY(0);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
}

.upload-btn.enhanced:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
  box-shadow: none;
}

.upload-limit-reached {
  width: 90px;
  height: 90px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  background: #f9fafb;
  display: flex;
  align-items: center;
  justify-content: center;
}

.limit-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.limit-icon {
  color: #10b981;
  font-size: 24px;
}

.limit-text {
  font-size: 11px;
  font-weight: 600;
  color: #374151;
  text-align: center;
}

.limit-hint {
  font-size: 10px;
  color: #6b7280;
  text-align: center;
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  .anticon {
    font-size: 24px;
    color: #6b7280;
  }

  span {
    font-size: 12px;
    color: #6b7280;
    text-align: center;
    line-height: 1.2;
  }
}

.upload-btn.enhanced .upload-content {
  gap: 6px;
}

.upload-icon {
  font-size: 28px;
  color: #3b82f6;
  transition: all 0.3s ease;
}

.upload-btn.enhanced:hover .upload-icon {
  color: #2563eb;
  transform: scale(1.1);
}

.upload-text {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  text-align: center;
  line-height: 1.2;
}

.upload-hint {
  font-size: 10px;
  color: #6b7280;
  text-align: center;
  line-height: 1.2;
  margin-top: 2px;
}

:deep(.ant-upload-list-picture-card-container) {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 12px !important;
  width: auto !important;
  margin: 0 !important;
  padding: 0 !important;
}

:deep(.ant-upload-list-picture-card) {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 12px !important;
  width: auto !important;
  margin: 0 !important;
  padding: 0 !important;
}

:deep(.ant-upload-list-picture-card .ant-upload-list-item) {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  margin: 0;
  border: 2px solid #e2e8f0;
  transition: all 0.3s ease;
}

:deep(.ant-upload-list-picture-card .ant-upload-list-item:hover) {
  border-color: #3b82f6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  transform: translateY(-2px);
}

:deep(.ant-upload-list-picture-card .ant-upload-list-item-thumbnail) {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

:deep(.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon) {
  color: #ef4444;
  font-size: 16px;
}

:deep(.ant-upload.ant-upload-select-picture-card) {
  width: 80px !important;
  height: 80px !important;
  border-radius: 8px;
  background: #fff;
  border: 2px dashed #d1d5db;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: all 0.3s ease;
  margin: 0 !important;
}

:deep(.ant-upload.ant-upload-select-picture-card:hover) {
  border-color: #3b82f6;
  background: #f8fafc;
}

/* 附件区域样式 */
.attachment-section {
  padding: 20px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.attachment-title {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  .anticon {
    color: #3b82f6;
    font-size: 16px;
  }
}

.attachment-title .upload-count {
  background: #3b82f6;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  margin-left: auto;
}

/* 文件列表样式 */
:deep(.ant-upload-list) {
  width: 100%;
  margin-top: 12px;
}

:deep(.ant-upload-list-item) {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #fff;
  padding: 12px 16px;
  margin-bottom: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

:deep(.ant-upload-list-item:hover) {
  border-color: #3b82f6;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transform: translateY(-1px);
}

:deep(.ant-upload-list-item-name) {
  color: #374151;
  font-size: 14px;
  font-weight: 500;
}

:deep(.ant-upload-list-item-card-actions) {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
}

:deep(.ant-upload-list-item-actions) {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
}

:deep(.ant-upload-list-item-actions .anticon) {
  color: #6b7280;
  font-size: 16px;
  transition: all 0.3s ease;
  padding: 4px;
  border-radius: 4px;
}

:deep(.ant-upload-list-item-actions .anticon:hover) {
  color: #ef4444;
  background: #fef2f2;
}

/* 上传进度条样式 */
:deep(.ant-upload-list-item-uploading) {
  border-color: #3b82f6;
  background: #eff6ff;
}

:deep(.ant-upload-list-item-uploading .ant-upload-list-item-name) {
  color: #3b82f6;
}

:deep(.ant-upload-list-item-uploading .ant-upload-list-item-progress) {
  top: 32px;
}

/* 隐藏上传中进度条的文字 */
:deep(.ant-upload-list-item-uploading .ant-upload-list-item-progress span) {
  display: none !important;
}

:deep(.ant-progress) {
  margin-top: 6px;
}

:deep(.ant-progress-bg) {
  background: #3b82f6;
}

/* 上传状态样式 */
:deep(.ant-upload-list-item-done) {
  border-color: #10b981;
  background: #ecfdf5;
}

:deep(.ant-upload-list-item-done .ant-upload-list-item-name) {
  color: #10b981;
}

:deep(.ant-upload-list-item-error) {
  border-color: #ef4444;
  background: #fef2f2;
}

:deep(.ant-upload-list-item-error .ant-upload-list-item-name) {
  color: #ef4444;
}

/* 表单操作按钮样式 */
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  margin: 0 -24px -24px -24px;
  border-radius: 0 0 12px 12px;
}

.cancel-btn {
  min-width: 100px;
  height: 40px;
  border-radius: 8px;
  background: #fff;
  color: #6b7280;
  border: 1px solid #d1d5db;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    border-color: #9ca3af;
    color: #374151;
    background: #f9fafb;
  }
}

.save-btn {
  min-width: 100px;
  height: 40px;
  border-radius: 8px;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: #fff;
  border: none;
  font-weight: 500;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  &:hover {
    background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
}

:deep .ant-calendar-picker-input {
  height: 40px;
}

:deep .ant-select-selection {
  height: 40px;
}

/* 文件大小显示 */
:deep(.ant-upload-list-item-info) {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

:deep(.ant-upload-list-item-info .ant-upload-list-item-name) {
  flex: 1;
  margin-right: 12px;
}

/* 文件类型图标 */
:deep(.ant-upload-list-item-icon) {
  margin-right: 12px;
  color: #6b7280;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .car-form-container {
    padding: 16px;
  }

  .form-card {
    margin-bottom: 16px;
  }

  .card-header {
    padding: 12px 16px;
  }

  .form-actions {
    padding: 16px;
    margin: 0 -16px -16px -16px;
  }
}

@media (max-width: 768px) {
  .modern-car-modal .ant-modal-content {
    margin: 0 16px;
  }

  .car-form-container {
    padding: 12px;
  }

  .form-card {
    margin-bottom: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .card-title {
    font-size: 14px;
  }

  .form-item {
    margin-bottom: 16px;
  }

  .form-actions {
    padding: 12px;
    margin: 0 -12px -12px -12px;
    flex-direction: column;

    .cancel-btn,
    .save-btn {
      width: 100%;
    }
  }

  .upload-thumb,
  .upload-btn {
    width: 60px;
    height: 60px;
  }

  :deep(.ant-upload-list-picture-card .ant-upload-list-item) {
    width: 60px;
    height: 60px;
  }

  :deep(.ant-upload.ant-upload-select-picture-card) {
    width: 60px !important;
    height: 60px !important;
  }
}

.custom-upload-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  min-height: 80px;
}

.custom-upload-thumb {
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid #e2e8f0;
  transition: all 0.3s ease;

  &:hover {
    border-color: #3b82f6;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
    transform: translateY(-2px);
  }
}

.custom-upload-remove {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  background: #ef4444;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
}

.custom-upload-remove:hover {
  background: #dc2626;
  transform: scale(1.1);
}

.custom-upload-remove .anticon {
  color: #fff;
  font-size: 12px;
  line-height: 1;
}

/* 上传文件删除按钮样式 */
.upload-remove {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 28px;
  height: 28px;
  background: #ef4444;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s ease;
  border: 3px solid #fff;
  box-shadow: 0 2px 12px rgba(239, 68, 68, 0.4), 0 0 0 1px rgba(239, 68, 68, 0.2);
}

.upload-remove:hover {
  background: #dc2626;
  transform: scale(1.15);
  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.6), 0 0 0 2px rgba(239, 68, 68, 0.3);
}

.upload-remove .anticon {
  color: #fff;
  font-size: 16px;
  line-height: 1;
  font-weight: bold;
}

.upload-remove::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border-radius: 50%;
  background: rgba(239, 68, 68, 0.1);
  z-index: -1;
  animation: pulse-delete 2s infinite;
}

@keyframes pulse-delete {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.ant-col-customize-input{
  padding: 12px 16px !important;
}
.ant-col-customize-select{
  padding: 12px 16px !important;
  .ant-select{
    width: 100% !important;
  }
}
</style>
